import RecaptchaFix from "../../utils/RecaptchaFix";
import BaseDeviseController from "./BaseDeviseController";

export default class PasswordNew extends BaseDeviseController {

    constructor() {
        super();
        this.recaptchaFix = new RecaptchaFix('#reset_password_form');
        this.initValidation();
        this.bindEvents();
        this.toggleSubmit();
    }


    bindEvents() {
        $(`#${this.resource_name}_email`).off( 'keyup', this.toggleSubmit ).on("keyup", () => this.toggleSubmit() )
        $('#btn-login').click(() => { document.getElementById('reset_password_form').reportValidity()})
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.recaptchaFix.onDestroy();
    }

    toggleSubmit() {
        let email = $(`#${this.resource_name}_email`).val().trim();
        if( email !== '' ) {
            $('#btn-login').removeClass('disabled')
        } else {
            $('#btn-login').addClass('disabled')
        }
    }

    initValidation() {
        application.setTemplateValidation({
            [`${this.resource_name}[email]`]: {
                required: true,
                email_validation: true
            },
        }, '#reset_password_form')
    }
}